webpackJsonp([26,39,41,42],{

/***/ 131:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ComponentFormFooter_vue__ = __webpack_require__(450);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e587aeb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ComponentFormFooter_vue__ = __webpack_require__(453);
function injectStyle (ssrContext) {
  __webpack_require__(451)
}
var normalizeComponent = __webpack_require__(20)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0e587aeb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ComponentFormFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e587aeb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ComponentFormFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 132:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_forms_ComponentFormFooter__ = __webpack_require__(131);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'component-form-footer': __WEBPACK_IMPORTED_MODULE_1__components_forms_ComponentFormFooter__["default"]
  },
  data: function data() {
    return {
      name: this.$options.name,
      newPosition: this.index + 1,
      isEditing: false,
      extensions: []
    };
  },

  props: {
    index: { type: Number, default: null },
    bus: { type: Object, default: null },
    positionMax: { type: Number, default: null },
    component: { type: Object, default: null },
    components: { type: Array, default: null },
    hideAll: { type: Boolean, default: false },
    lock: { type: Boolean, default: false },
    previewSize: { type: String, default: 'native' },
    inPreview: { type: Boolean, default: false }
  },
  computed: {
    contents: {
      get: function get() {
        return this.component.contents;
      }
    },
    url: {
      get: function get() {
        return this.$store.getters['wordpress/account/url'];
      }
    },
    meta: {
      get: function get() {
        return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].components[this.component.id].meta;
      }
    },
    posts: {
      get: function get() {
        return this.$store.getters['wordpress/posts/all'];
      }
    },
    publishedPosts: {
      get: function get() {
        return this.$store.getters['wordpress/posts/published'];
      }
    },
    pages: {
      get: function get() {
        return this.$store.getters['wordpress/pages/all'];
      }
    },
    publishedPages: {
      get: function get() {
        return this.$store.getters['wordpress/pages/published'];
      }
    },
    media: {
      get: function get() {
        return this.$store.getters['wordpress/media/all'];
      }
    },
    themes: {
      get: function get() {
        return this.$store.getters['wordpress/themes/all'];
      }
    },
    settings: {
      get: function get() {
        return this.$store.getters['wordpress/settings/all'];
      }
    },
    sectionId: {
      get: function get() {
        return this.componentId(this);
      }
    },
    sectionClass: {
      get: function get() {
        return this.meta.file + ' ' + this.meta.file + '-' + this._uid + ' ' + (this.contents.bg.isCustom ? this.meta.file + '-' + this._uid + '-bg' : 'theme-base-bg-color') + ' slide';
      }
    },
    sectionClassArray: {
      get: function get() {
        return [this.meta.file, 'slide', 'theme-base-bg-color'];
      }
    },
    sectionStyle: {
      get: function get() {
        return this.contents.bg.isCustom ? 'background-color:' + this.contents.bg.color : '';
      }
    },
    containerClass: {
      get: function get() {
        return (this.contents.fullWidth ? '' : 'container') + (this.contents.padding.y ? ' py' + this.contents.padding.y : '');
      }
    },
    containerClassArray: {
      get: function get() {
        return [this.contents.fullWidth ? '' : 'container', 'py' + this.contents.padding.y];
      }
    },
    gridClass: {
      get: function get() {
        return 'grid grid-mx' + this.contents.layout.margin + ' grid-my' + this.contents.layout.margin + ' grid-1-' + this.contents.layout.s + ' grid-1-' + this.contents.layout.m + '-m grid-1-' + this.contents.layout.l + '-l';
      }
    },
    gridClassArray: {
      get: function get() {
        return ['grid', 'grid-mx' + this.contents.layout.margin, 'grid-my' + this.contents.layout.margin, 'grid-1-' + this.contents.layout.s, 'grid-1-' + this.contents.layout.m + '-m', 'grid-1-' + this.contents.layout.l + '-l'];
      }
    }
  },
  methods: {
    /**
     各コンポーネントに付与するIDを返す関数
     */
    componentId: function componentId(that) {
      return that.component ? that.component.meta.file + '-' + that._uid : that.meta.file + '-' + that._uid;
    },

    /**
     * uuid生成関数
     *
     * @see https://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript/2117523#2117523
     */
    uuidv4: function uuidv4() {
      return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, function (c) {
        return (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16);
      });
    },

    /**
     * 文字色／背景色のインラインスタイルを取得する関数
     */
    getThemeInlineStyle: function getThemeInlineStyle(prop, type) {
      return prop + ': rgba(' + this.themes.colors[type].rgba.r + ', ' + this.themes.colors[type].rgba.g + ', ' + this.themes.colors[type].rgba.b + ', ' + this.themes.colors[type].rgba.a + ')';
    },

    /**
     * 引数で与えられるIDの固定ページを返す関数
     */
    getPageById: function getPageById(id) {
      return this.pages.find(function (page) {
        return page.id === id;
      });
    },

    /**
     * 引数で与えられるIDの固定ページの子ページを返す関数
     */
    getSubPagesById: function getSubPagesById(id) {
      return this.pages.filter(function (page) {
        return page.parent === id && page.status === 'publish';
      });
    },

    /**
     * 適用ボタンを押すとthis.components.contentsからHTMLとCSSを
     * 生成してupdateイベントを発火する
     *
     * 適用ボタンを押すとthis.component.htmlとthis.component.cssを更新する
     */
    updateComponent: function updateComponent() {
      if (false) console.log('Running updateComponent of ' + this.name + '...');

      this.component.html = this.generateHtml(this.component.contents);
      this.component.css = this.generateCss(this.component.contents);
      this.$emit('update', { component: this.component, newPosition: this.newPosition });
      this.isEditing = false;
    },

    updateComponentUid: function updateComponentUid() {
      /**
       * this._uid は vue でコンポーネントが生成された際に発行される。
       * この値は発行時にユニークであるため、あとでコンポーネントが追加されたり
       * コンポーネント入れ替え時に新規に発行されても、最初に発行された this._uid とは被らない（はず）。
       * updateComponentUid が呼び出されたらイベントバスで uid-updated イベントを発火して、
       * this.component._uid に this._uid を代入して最新の this._uid をコンポーネント内に保持する
       *
       */
      if (this.component._uid !== this._uid) {
        if (false) console.log('%c_uid has been changed: ' + this.component._uid + ' -> ' + this._uid, 'color:blue');
        this.bus.$emit('uid-updated', this);
        this.component._uid = this._uid;
        if (false) console.log('%c_uid has been updated: this.component._uid = ' + this.component._uid, 'color:teal');
      }
    },

    updateComponentAndUid: function updateComponentAndUid() {
      this.updateComponentUid();
      this.updateComponent();
    },

    /**
     * コンポーネント削除用のdeleteイベントを発火する
     */
    deleteComponent: function deleteComponent() {
      this.$emit('delete');
      this.isEditing = false;
    }
  },
  /**
   * コンポーネント生成時にHTMLとCSSを生成してupdateイベントを発火する
   */
  created: function created() {
    if (!this.component._uid) this.component._uid = this._uid;
    if (this.component.uid) delete this.component.uid;
    this.updateComponent();
  },
  /**
   * コンポーネントマウント時にmountedイベントを発火する
   */
  mounted: function mounted() {
    this.$emit('mounted');
    this.bus.$on('update-child', this.updateComponentAndUid);
  }
});

/***/ }),

/***/ 136:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelectLinks_vue__ = __webpack_require__(618);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36fbd416_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelectLinks_vue__ = __webpack_require__(702);
function injectStyle (ssrContext) {
  __webpack_require__(700)
}
var normalizeComponent = __webpack_require__(20)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-36fbd416"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelectLinks_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36fbd416_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelectLinks_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 148:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FiveBlockLinksForDriving_vue__ = __webpack_require__(802);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d09bbae_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FiveBlockLinksForDriving_vue__ = __webpack_require__(931);
function injectStyle (ssrContext) {
  __webpack_require__(920)
}
var normalizeComponent = __webpack_require__(20)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3d09bbae"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FiveBlockLinksForDriving_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d09bbae_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FiveBlockLinksForDriving_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 450:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'component-form-footer',
  methods: {
    onDelete: function onDelete() {
      this.$emit('delete');
    },
    onCancel: function onCancel() {
      this.$emit('cancel');
    },
    onUpdate: function onUpdate() {
      this.$emit('update');
    }
  }
});

/***/ }),

/***/ 451:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(452);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(342)("727fe8b8", content, true, {});

/***/ }),

/***/ 452:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(341)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"ComponentFormFooter.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 453:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-button',{attrs:{"type":"danger"},on:{"click":function($event){_vm.onDelete()}}},[_vm._v("削除")]),_vm._v(" "),_c('el-button',{on:{"click":_vm.onCancel}},[_vm._v("キャンセル")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.onUpdate}},[_vm._v("適用")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 618:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'select-links',
  props: {
    value: {
      type: Array
    },
    limit: {
      type: Number,
      default: 6
    }
  },
  computed: {
    pages: {
      get: function get() {
        return this.$store.getters['wordpress/pages/all'];
      }
    },
    publishedPages: {
      get: function get() {
        return this.$store.getters['wordpress/pages/published'];
      }
    }
  },
  methods: {
    onChange: function onChange(newValue) {
      this.$emit('input', newValue);
    }
  }
});

/***/ }),

/***/ 700:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(701);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(342)("a098fdce", content, true, {});

/***/ }),

/***/ 701:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(341)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"SelectLinks.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 702:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-select',{staticClass:"width-100",attrs:{"multiple":_vm.limit > 1,"multiple-limit":_vm.limit,"value-key":"link","value":_vm.value,"placeholder":"固定ページから選択"},on:{"change":_vm.onChange}},[_vm._l((_vm.publishedPages),function(page){return [_c('el-option',{key:page.link,staticClass:"el-opp",attrs:{"label":page.title.rendered,"value":page.id}})]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 802:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_mixins_ComponentBase__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_forms_SelectLinks__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers__ = __webpack_require__(14);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'five-block-links',
  components: {
    'select-links': __WEBPACK_IMPORTED_MODULE_1__components_forms_SelectLinks__["default"]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_0__components_mixins_ComponentBase__["default"]],
  data: function data() {
    return {
      labelWidth: '120px',
      icons: Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["b" /* getFontawesomeIcons */])()
      // icons: [
      //   'car', 'motorcycle', 'truck', 'taxi', 'id-card'
      // ]
    };
  },

  methods: {
    getCssForThemeColors: function getCssForThemeColors() {
      return '.' + this.meta.file + '-' + this._uid + '-a-bg-color-hover:hover {background-color: ' + this.contents.theme.color + '}';
    },
    onThemeChange: function onThemeChange(value) {
      var head = document.head;
      var style = document.createElement('style');
      style.type = 'text/css';
      if (style.styleSheet) {
        style.styleSheet.cssText = this.getCssForThemeColors();
      } else {
        style.appendChild(document.createTextNode(this.getCssForThemeColors()));
      }
      head.appendChild(style);
    },
    /**
     * this.contentsからコンポーネントのHTMLを生成
     */
    generateHtml: function generateHtml(contents) {
      var _this = this;

      var borderClass = contents.theme.isCustom ? this.meta.file + '-' + this._uid + '-border' : '';
      var hoverClass = contents.theme.isCustom ? this.meta.file + '-' + this._uid + '-a-bg-color-hover' : '';
      var linksHtml = '';
      if (contents.links.reduce(function (prev, curr) {
        return curr.pageId ? prev + 1 : prev;
      }, 0) > 0) {
        linksHtml += '<ul class="' + this.meta.file + '-list flex justify-center items-center theme-accent-border-color ' + borderClass + '">';
        contents.links.forEach(function (item) {
          linksHtml += '<li class="' + _this.meta.file + '-item theme-accent-border-color ' + borderClass + '"><a class="' + _this.meta.file + '-a theme-accent-bg-color-hover ' + hoverClass + '" href="' + _this.getPageById(item.pageId).link + '"><i class="fa fa-' + item.icon + '" aria-hidden="true"></i>' + _this.getPageById(item.pageId).title.rendered + '</a></li>';
        });
        linksHtml += '</ul>';
      }
      return ('\n      <section id="' + this.sectionId + '" class="' + this.sectionClass + '">\n        <div class="' + this.containerClass + '">\n          <h2 class="' + this.meta.file + '-h2">' + contents.heading.text + '</h2>\n          <p class="' + this.meta.file + '-p">' + contents.paragraph.text + '</p>\n          ' + linksHtml + '\n        </div>\n      </section>\n      ').trim().replace(/>\s+</g, '><');
    },
    /**
     * this.contentsからコンポーネントのCSSを生成
     */
    generateCss: function generateCss(contents) {
      var layout = __webpack_require__(922)("./" + this.meta.file + '.scss');
      var theme = '';
      if (contents.bg.isCustom) {
        theme += '.' + this.meta.file + '-' + this._uid + '-bg {background-color:' + contents.bg.color + '}';
      }
      if (contents.theme.isCustom) {
        theme += '.' + this.meta.file + '-' + this._uid + '-border {border-color: ' + this.contents.theme.color + '}';
        theme += this.getCssForThemeColors();
      }
      return { layout: layout, theme: theme };
    }
  },
  created: function created() {
    this.onThemeChange();

    // migration
    if (!this.contents.padding) this.contents.padding = { y: 4 };
  }
});

/***/ }),

/***/ 920:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(921);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(342)("a2bc9f66", content, true, {});

/***/ }),

/***/ 921:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(341)(true);
// imports


// module
exports.push([module.i, ".native .FiveBlockLinksForDriving-h2[data-v-3d09bbae]{text-align:center}.native .FiveBlockLinksForDriving-p[data-v-3d09bbae]{margin-bottom:3em}.native .FiveBlockLinksForDriving-list[data-v-3d09bbae]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;border-width:1px;border-style:solid}.native .FiveBlockLinksForDriving-item[data-v-3d09bbae]{border-width:1px;border-style:solid none none;width:100%}.native .FiveBlockLinksForDriving-item[data-v-3d09bbae]:first-child{border-top-style:none}.native .FiveBlockLinksForDriving-a[data-v-3d09bbae]{display:block;padding:2em 0;line-height:1;font-weight:700;text-align:center}.native .FiveBlockLinksForDriving-a .fa[data-v-3d09bbae]{margin-right:.5em}@media (min-width:768px){.native .FiveBlockLinksForDriving-list[data-v-3d09bbae]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-ms-flex-wrap:wrap;flex-wrap:wrap}.native .FiveBlockLinksForDriving-item[data-v-3d09bbae]{border-width:1px;border-style:solid;width:33.33333%}.native .FiveBlockLinksForDriving-item[data-v-3d09bbae]:first-child,.native .FiveBlockLinksForDriving-item[data-v-3d09bbae]:nth-child(2){border-width:1px;border-style:solid;width:50%}}@media (min-width:1025px){.native .FiveBlockLinksForDriving-a[data-v-3d09bbae]:hover{-webkit-transition:all .15s;transition:all .15s}}.desktop .FiveBlockLinksForDriving-h2[data-v-3d09bbae],.smartphone .FiveBlockLinksForDriving-h2[data-v-3d09bbae],.tablet .FiveBlockLinksForDriving-h2[data-v-3d09bbae]{text-align:center}.desktop .FiveBlockLinksForDriving-p[data-v-3d09bbae],.smartphone .FiveBlockLinksForDriving-p[data-v-3d09bbae],.tablet .FiveBlockLinksForDriving-p[data-v-3d09bbae]{margin-bottom:3em}.desktop .FiveBlockLinksForDriving-list[data-v-3d09bbae],.smartphone .FiveBlockLinksForDriving-list[data-v-3d09bbae],.tablet .FiveBlockLinksForDriving-list[data-v-3d09bbae]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;border-width:1px;border-style:solid}.desktop .FiveBlockLinksForDriving-item[data-v-3d09bbae],.smartphone .FiveBlockLinksForDriving-item[data-v-3d09bbae],.tablet .FiveBlockLinksForDriving-item[data-v-3d09bbae]{border-width:1px;border-style:solid none none;width:100%}.desktop .FiveBlockLinksForDriving-item[data-v-3d09bbae]:first-child,.smartphone .FiveBlockLinksForDriving-item[data-v-3d09bbae]:first-child,.tablet .FiveBlockLinksForDriving-item[data-v-3d09bbae]:first-child{border-top-style:none}.desktop .FiveBlockLinksForDriving-a[data-v-3d09bbae],.smartphone .FiveBlockLinksForDriving-a[data-v-3d09bbae],.tablet .FiveBlockLinksForDriving-a[data-v-3d09bbae]{display:block;padding:2em 0;line-height:1;font-weight:700;text-align:center}.desktop .FiveBlockLinksForDriving-a .fa[data-v-3d09bbae],.smartphone .FiveBlockLinksForDriving-a .fa[data-v-3d09bbae],.tablet .FiveBlockLinksForDriving-a .fa[data-v-3d09bbae]{margin-right:.5em}.desktop .FiveBlockLinksForDriving-list[data-v-3d09bbae],.tablet .FiveBlockLinksForDriving-list[data-v-3d09bbae]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-ms-flex-wrap:wrap;flex-wrap:wrap}.desktop .FiveBlockLinksForDriving-item[data-v-3d09bbae],.tablet .FiveBlockLinksForDriving-item[data-v-3d09bbae]{border-width:1px;border-style:solid;width:33.33333%}.desktop .FiveBlockLinksForDriving-item[data-v-3d09bbae]:first-child,.desktop .FiveBlockLinksForDriving-item[data-v-3d09bbae]:nth-child(2),.tablet .FiveBlockLinksForDriving-item[data-v-3d09bbae]:first-child,.tablet .FiveBlockLinksForDriving-item[data-v-3d09bbae]:nth-child(2){border-width:1px;border-style:solid;width:50%}.desktop .FiveBlockLinksForDriving-a[data-v-3d09bbae]:hover{-webkit-transition:all .15s;transition:all .15s}", "", {"version":3,"sources":["/Users/yuki/Public/wp-admin/src/components/contents/FiveBlockLinksForDriving/FiveBlockLinksForDriving.vue"],"names":[],"mappings":"AAmCA,sDACI,iBAAmB,CACtB,AACD,qDACI,iBAAmB,CACtB,AACD,wDACI,4BAA6B,AAC7B,6BAA8B,AAC9B,0BAA2B,AAC3B,sBAAuB,AACvB,iBAAkB,AAClB,kBAAoB,CACvB,AACD,wDACI,iBAAkB,AAClB,6BAA8B,AAC9B,UAAY,CACf,AACD,oEACM,qBAAuB,CAC5B,AACD,qDACI,cAAe,AACf,cAAe,AACf,cAAe,AACf,gBAAkB,AAClB,iBAAmB,CACtB,AACD,yDACM,iBAAmB,CACxB,AACD,yBAmBA,wDACQ,8BAA+B,AAC/B,6BAA8B,AAC9B,uBAAwB,AACxB,mBAAoB,AACpB,mBAAoB,AACpB,cAAgB,CACvB,AACD,wDACQ,iBAAkB,AAClB,mBAAoB,AACpB,eAAiB,CACxB,AACD,yIACU,iBAAkB,AAClB,mBAAoB,AACpB,SAAW,CACpB,CACA,AACD,0BAmBA,2DACQ,4BAA8B,AAC9B,mBAAsB,CAC7B,CACA,AAqBD,uKAGI,iBAAmB,CACtB,AACD,oKAGI,iBAAmB,CACtB,AACD,6KAGI,4BAA6B,AAC7B,6BAA8B,AAC9B,0BAA2B,AAC3B,sBAAuB,AACvB,iBAAkB,AAClB,kBAAoB,CACvB,AACD,6KAGI,iBAAkB,AAClB,6BAA8B,AAC9B,UAAY,CACf,AACD,iNAGM,qBAAuB,CAC5B,AACD,oKAGI,cAAe,AACf,cAAe,AACf,cAAe,AACf,gBAAkB,AAClB,iBAAmB,CACtB,AACD,gLAGM,iBAAmB,CACxB,AAoBD,iHAEI,8BAA+B,AAC/B,6BAA8B,AAC9B,uBAAwB,AACxB,mBAAoB,AACpB,mBAAoB,AACpB,cAAgB,CACnB,AACD,iHAEI,iBAAkB,AAClB,mBAAoB,AACpB,eAAiB,CACpB,AACD,oRAGM,iBAAkB,AAClB,mBAAoB,AACpB,SAAW,CAChB,AAmBD,4DACI,4BAA8B,AAC9B,mBAAsB,CACzB","file":"FiveBlockLinksForDriving.vue","sourcesContent":["\n.native[data-v-3d09bbae] {\n  /**\n *\n * Layout\n *\n */\n  /**\n * Columns\n */\n  /**\n * Component\n */\n  /**\n *\n * Application specific variables\n *\n */\n  /**\n *\n * Layout\n *\n */\n  /**\n * Columns\n */\n  /**\n * Component\n */\n  /**\n *\n * Application specific variables\n *\n */\n}\n.native .FiveBlockLinksForDriving-h2[data-v-3d09bbae] {\n    text-align: center;\n}\n.native .FiveBlockLinksForDriving-p[data-v-3d09bbae] {\n    margin-bottom: 3em;\n}\n.native .FiveBlockLinksForDriving-list[data-v-3d09bbae] {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    border-width: 1px;\n    border-style: solid;\n}\n.native .FiveBlockLinksForDriving-item[data-v-3d09bbae] {\n    border-width: 1px;\n    border-style: solid none none;\n    width: 100%;\n}\n.native .FiveBlockLinksForDriving-item[data-v-3d09bbae]:first-child {\n      border-top-style: none;\n}\n.native .FiveBlockLinksForDriving-a[data-v-3d09bbae] {\n    display: block;\n    padding: 2em 0;\n    line-height: 1;\n    font-weight: bold;\n    text-align: center;\n}\n.native .FiveBlockLinksForDriving-a .fa[data-v-3d09bbae] {\n      margin-right: .5em;\n}\n@media (min-width: 768px) {\n.native[data-v-3d09bbae] {\n      /**\n *\n * Layout\n *\n */\n      /**\n * Columns\n */\n      /**\n * Component\n */\n      /**\n *\n * Application specific variables\n *\n */\n}\n.native .FiveBlockLinksForDriving-list[data-v-3d09bbae] {\n        -webkit-box-orient: horizontal;\n        -webkit-box-direction: normal;\n        -ms-flex-direction: row;\n        flex-direction: row;\n        -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n}\n.native .FiveBlockLinksForDriving-item[data-v-3d09bbae] {\n        border-width: 1px;\n        border-style: solid;\n        width: 33.33333%;\n}\n.native .FiveBlockLinksForDriving-item[data-v-3d09bbae]:nth-child(1), .native .FiveBlockLinksForDriving-item[data-v-3d09bbae]:nth-child(2) {\n          border-width: 1px;\n          border-style: solid;\n          width: 50%;\n}\n}\n@media (min-width: 1025px) {\n.native[data-v-3d09bbae] {\n      /**\n *\n * Layout\n *\n */\n      /**\n * Columns\n */\n      /**\n * Component\n */\n      /**\n *\n * Application specific variables\n *\n */\n}\n.native .FiveBlockLinksForDriving-a[data-v-3d09bbae]:hover {\n        -webkit-transition: all 150ms;\n        transition: all 150ms;\n}\n}\n.smartphone[data-v-3d09bbae],\n.tablet[data-v-3d09bbae],\n.desktop[data-v-3d09bbae] {\n  /**\n *\n * Layout\n *\n */\n  /**\n * Columns\n */\n  /**\n * Component\n */\n  /**\n *\n * Application specific variables\n *\n */\n}\n.smartphone .FiveBlockLinksForDriving-h2[data-v-3d09bbae],\n  .tablet .FiveBlockLinksForDriving-h2[data-v-3d09bbae],\n  .desktop .FiveBlockLinksForDriving-h2[data-v-3d09bbae] {\n    text-align: center;\n}\n.smartphone .FiveBlockLinksForDriving-p[data-v-3d09bbae],\n  .tablet .FiveBlockLinksForDriving-p[data-v-3d09bbae],\n  .desktop .FiveBlockLinksForDriving-p[data-v-3d09bbae] {\n    margin-bottom: 3em;\n}\n.smartphone .FiveBlockLinksForDriving-list[data-v-3d09bbae],\n  .tablet .FiveBlockLinksForDriving-list[data-v-3d09bbae],\n  .desktop .FiveBlockLinksForDriving-list[data-v-3d09bbae] {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    border-width: 1px;\n    border-style: solid;\n}\n.smartphone .FiveBlockLinksForDriving-item[data-v-3d09bbae],\n  .tablet .FiveBlockLinksForDriving-item[data-v-3d09bbae],\n  .desktop .FiveBlockLinksForDriving-item[data-v-3d09bbae] {\n    border-width: 1px;\n    border-style: solid none none;\n    width: 100%;\n}\n.smartphone .FiveBlockLinksForDriving-item[data-v-3d09bbae]:first-child,\n    .tablet .FiveBlockLinksForDriving-item[data-v-3d09bbae]:first-child,\n    .desktop .FiveBlockLinksForDriving-item[data-v-3d09bbae]:first-child {\n      border-top-style: none;\n}\n.smartphone .FiveBlockLinksForDriving-a[data-v-3d09bbae],\n  .tablet .FiveBlockLinksForDriving-a[data-v-3d09bbae],\n  .desktop .FiveBlockLinksForDriving-a[data-v-3d09bbae] {\n    display: block;\n    padding: 2em 0;\n    line-height: 1;\n    font-weight: bold;\n    text-align: center;\n}\n.smartphone .FiveBlockLinksForDriving-a .fa[data-v-3d09bbae],\n    .tablet .FiveBlockLinksForDriving-a .fa[data-v-3d09bbae],\n    .desktop .FiveBlockLinksForDriving-a .fa[data-v-3d09bbae] {\n      margin-right: .5em;\n}\n.tablet[data-v-3d09bbae],\n.desktop[data-v-3d09bbae] {\n  /**\n *\n * Layout\n *\n */\n  /**\n * Columns\n */\n  /**\n * Component\n */\n  /**\n *\n * Application specific variables\n *\n */\n}\n.tablet .FiveBlockLinksForDriving-list[data-v-3d09bbae],\n  .desktop .FiveBlockLinksForDriving-list[data-v-3d09bbae] {\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: row;\n    flex-direction: row;\n    -ms-flex-wrap: wrap;\n    flex-wrap: wrap;\n}\n.tablet .FiveBlockLinksForDriving-item[data-v-3d09bbae],\n  .desktop .FiveBlockLinksForDriving-item[data-v-3d09bbae] {\n    border-width: 1px;\n    border-style: solid;\n    width: 33.33333%;\n}\n.tablet .FiveBlockLinksForDriving-item[data-v-3d09bbae]:nth-child(1), .tablet .FiveBlockLinksForDriving-item[data-v-3d09bbae]:nth-child(2),\n    .desktop .FiveBlockLinksForDriving-item[data-v-3d09bbae]:nth-child(1),\n    .desktop .FiveBlockLinksForDriving-item[data-v-3d09bbae]:nth-child(2) {\n      border-width: 1px;\n      border-style: solid;\n      width: 50%;\n}\n.desktop[data-v-3d09bbae] {\n  /**\n *\n * Layout\n *\n */\n  /**\n * Columns\n */\n  /**\n * Component\n */\n  /**\n *\n * Application specific variables\n *\n */\n}\n.desktop .FiveBlockLinksForDriving-a[data-v-3d09bbae]:hover {\n    -webkit-transition: all 150ms;\n    transition: all 150ms;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 922:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./FiveBlockLinksForDriving.l.scss": 923,
	"./FiveBlockLinksForDriving.m.scss": 925,
	"./FiveBlockLinksForDriving.s.scss": 927,
	"./FiveBlockLinksForDriving.scss": 929
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 922;

/***/ }),

/***/ 923:
/***/ (function(module, exports, __webpack_require__) {

// css-to-string-loader: transforms styles from css-loader to a string output

// Get the styles
var styles = __webpack_require__(924);

if (typeof styles === 'string') {
  // Return an existing string
  module.exports = styles;
} else {
  // Call the custom toString method from css-loader module
  module.exports = styles.toString();
}

/***/ }),

/***/ 924:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(341)(false);
// imports


// module
exports.push([module.i, ".FiveBlockLinksForDriving-a:hover{-webkit-transition:all .15s;transition:all .15s}", ""]);

// exports


/***/ }),

/***/ 925:
/***/ (function(module, exports, __webpack_require__) {

// css-to-string-loader: transforms styles from css-loader to a string output

// Get the styles
var styles = __webpack_require__(926);

if (typeof styles === 'string') {
  // Return an existing string
  module.exports = styles;
} else {
  // Call the custom toString method from css-loader module
  module.exports = styles.toString();
}

/***/ }),

/***/ 926:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(341)(false);
// imports


// module
exports.push([module.i, ".FiveBlockLinksForDriving-list{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-ms-flex-wrap:wrap;flex-wrap:wrap}.FiveBlockLinksForDriving-item{border-width:1px;border-style:solid;width:33.33333%}.FiveBlockLinksForDriving-item:first-child,.FiveBlockLinksForDriving-item:nth-child(2){border-width:1px;border-style:solid;width:50%}", ""]);

// exports


/***/ }),

/***/ 927:
/***/ (function(module, exports, __webpack_require__) {

// css-to-string-loader: transforms styles from css-loader to a string output

// Get the styles
var styles = __webpack_require__(928);

if (typeof styles === 'string') {
  // Return an existing string
  module.exports = styles;
} else {
  // Call the custom toString method from css-loader module
  module.exports = styles.toString();
}

/***/ }),

/***/ 928:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(341)(false);
// imports


// module
exports.push([module.i, ".FiveBlockLinksForDriving-h2{text-align:center}.FiveBlockLinksForDriving-p{margin-bottom:3em}.FiveBlockLinksForDriving-list{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;border-width:1px;border-style:solid}.FiveBlockLinksForDriving-item{border-width:1px;border-style:solid none none;width:100%}.FiveBlockLinksForDriving-item:first-child{border-top-style:none}.FiveBlockLinksForDriving-a{display:block;padding:2em 0;line-height:1;font-weight:700;text-align:center}.FiveBlockLinksForDriving-a .fa{margin-right:.5em}", ""]);

// exports


/***/ }),

/***/ 929:
/***/ (function(module, exports, __webpack_require__) {

// css-to-string-loader: transforms styles from css-loader to a string output

// Get the styles
var styles = __webpack_require__(930);

if (typeof styles === 'string') {
  // Return an existing string
  module.exports = styles;
} else {
  // Call the custom toString method from css-loader module
  module.exports = styles.toString();
}

/***/ }),

/***/ 930:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(341)(false);
// imports


// module
exports.push([module.i, ".FiveBlockLinksForDriving-h2{text-align:center}.FiveBlockLinksForDriving-p{margin-bottom:3em}.FiveBlockLinksForDriving-list{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;border-width:1px;border-style:solid}.FiveBlockLinksForDriving-item{border-width:1px;border-style:solid none none;width:100%}.FiveBlockLinksForDriving-item:first-child{border-top-style:none}.FiveBlockLinksForDriving-a{display:block;padding:2em 0;line-height:1;font-weight:700;text-align:center}.FiveBlockLinksForDriving-a .fa{margin-right:.5em}@media (min-width:768px){.FiveBlockLinksForDriving-list{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-ms-flex-wrap:wrap;flex-wrap:wrap}.FiveBlockLinksForDriving-item{border-width:1px;border-style:solid;width:33.33333%}.FiveBlockLinksForDriving-item:first-child,.FiveBlockLinksForDriving-item:nth-child(2){border-width:1px;border-style:solid;width:50%}}@media (min-width:1025px){.FiveBlockLinksForDriving-a:hover{-webkit-transition:all .15s;transition:all .15s}}", ""]);

// exports


/***/ }),

/***/ 931:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.contents)?[_c('div',{class:['component', _vm.previewSize],style:(_vm.hideAll ? 'display:none' : '')},[_c('div',{on:{"click":function($event){_vm.isEditing = !_vm.isEditing}}},[_c('section',{class:_vm.sectionClassArray,style:(_vm.sectionStyle)},[_c('div',{class:_vm.containerClassArray},[_c('h2',{staticClass:"FiveBlockLinksForDriving-h2"},[_vm._v(_vm._s(_vm.contents.heading.text))]),_vm._v(" "),_c('p',{staticClass:"FiveBlockLinksForDriving-p"},[_vm._v(_vm._s(_vm.contents.paragraph.text))]),_vm._v(" "),_c('ul',{staticClass:"FiveBlockLinksForDriving-list flex justify-center items-center theme-accent-border-color",style:(_vm.contents.theme.isCustom ? 'border-color:' + _vm.contents.theme.color : '')},[_vm._l((_vm.contents.links),function(item,i){return [(item.pageId)?[_c('li',{staticClass:"FiveBlockLinksForDriving-item theme-accent-border-color",style:(_vm.contents.theme.isCustom ? 'border-color:' + _vm.contents.theme.color : '')},[_c('a',{class:['FiveBlockLinksForDriving-a', 'theme-accent-bg-color-hover', _vm.contents.theme.isCustom ? 'FiveBlockLinksForDriving-' + _vm._uid + '-a-bg-color-hover': '']},[_c('i',{class:['fa', ' fa-' + item.icon],attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.getPageById(item.pageId).title.rendered))])])]:_vm._e()]})],2)])])])]),_vm._v(" "),_c('el-form',{class:['component-contents-form', ' p2', _vm.lock ? 'hide' : _vm.isEditing ? 'show' : 'hide'],attrs:{"model":_vm.contents}},[_c('h2',[_vm._v("コンポーネントのコンテンツを編集")]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"コンポーネント配置順序","label-width":"170px"}},[_c('el-input-number',{attrs:{"controls-position":"right","min":1,"max":_vm.positionMax},model:{value:(_vm.newPosition),callback:function ($$v) {_vm.newPosition=$$v},expression:"newPosition"}}),_c('span',{staticClass:"pl4"},[_vm._v("1から"+_vm._s(_vm.positionMax)+"まで")])],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"見出し","label-width":_vm.labelWidth}},[_c('el-input',{attrs:{"type":"textarea","autosize":{minRows:2},"auto-complete":"off"},model:{value:(_vm.contents.heading.text),callback:function ($$v) {_vm.$set(_vm.contents.heading, "text", $$v)},expression:"contents.heading.text"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"段落","label-width":_vm.labelWidth}},[_c('el-input',{attrs:{"type":"textarea","autosize":{minRows:2},"auto-complete":"off"},model:{value:(_vm.contents.paragraph.text),callback:function ($$v) {_vm.$set(_vm.contents.paragraph, "text", $$v)},expression:"contents.paragraph.text"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"リンク","label-width":_vm.labelWidth}},[_vm._l((_vm.contents.links),function(item,index){return [_c('div',[_c('el-select',{staticClass:"width-20",staticStyle:{"display":"inline-block"},attrs:{"placeholder":"アイコンリストから選択"},model:{value:(_vm.contents.links[index].icon),callback:function ($$v) {_vm.$set(_vm.contents.links[index], "icon", $$v)},expression:"contents.links[index].icon"}},_vm._l((_vm.icons),function(icon){return _c('el-option',{key:icon.value,staticClass:"el-opp",attrs:{"label":icon.label,"value":icon.value}},[_c('span',{staticStyle:{"display":"inline-block","width":"2em"}},[_c('i',{class:['fa', ' fa-' + icon.value],staticStyle:{"font-size":"1.5em"},attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('span',{staticStyle:{"float":"right"}},[_vm._v(_vm._s(icon.value))])])})),_vm._v(" "),_c('el-select',{staticClass:"width-50",staticStyle:{"display":"inline-block"},attrs:{"value-key":"link","placeholder":"固定ページから選択"},model:{value:(_vm.contents.links[index].pageId),callback:function ($$v) {_vm.$set(_vm.contents.links[index], "pageId", $$v)},expression:"contents.links[index].pageId"}},_vm._l((_vm.publishedPages),function(page){return _c('el-option',{key:page.link,staticClass:"el-opp",attrs:{"label":page.title.rendered,"value":page.id}})}))],1)]})],2),_vm._v(" "),_c('el-form-item',{attrs:{"label":"ボーダー・ホバー背景色","label-width":_vm.labelWidth}},[_c('div',[_c('el-checkbox',{model:{value:(_vm.contents.theme.isCustom),callback:function ($$v) {_vm.$set(_vm.contents.theme, "isCustom", $$v)},expression:"contents.theme.isCustom"}},[_vm._v("ボーダー・ホバー背景色を指定する")])],1),_vm._v(" "),_c('div',{staticClass:"items-center",style:({display: _vm.contents.theme.isCustom ? 'flex' : 'none'})},[_c('el-color-picker',{attrs:{"show-alpha":""},on:{"change":_vm.onThemeChange},model:{value:(_vm.contents.theme.color),callback:function ($$v) {_vm.$set(_vm.contents.theme, "color", $$v)},expression:"contents.theme.color"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.contents.theme.color))])],1)]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"スライド上下の余白","label-width":_vm.labelWidth}},[_c('el-slider',{attrs:{"step":1,"min":0,"max":10},model:{value:(_vm.contents.padding.y),callback:function ($$v) {_vm.$set(_vm.contents.padding, "y", $$v)},expression:"contents.padding.y"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"スライド背景色","label-width":_vm.labelWidth}},[_c('div',[_c('el-checkbox',{model:{value:(_vm.contents.bg.isCustom),callback:function ($$v) {_vm.$set(_vm.contents.bg, "isCustom", $$v)},expression:"contents.bg.isCustom"}},[_vm._v("スライドの背景色を指定する")])],1),_vm._v(" "),_c('div',{staticClass:"items-center",style:({display: _vm.contents.bg.isCustom ? 'flex' : 'none'})},[_c('el-color-picker',{attrs:{"show-alpha":""},model:{value:(_vm.contents.bg.color),callback:function ($$v) {_vm.$set(_vm.contents.bg, "color", $$v)},expression:"contents.bg.color"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.contents.bg.color))])],1)]),_vm._v(" "),_c('div',{staticClass:"component-contents-controller flex justify-end items-center"},[_c('component-form-footer',{on:{"delete":function($event){_vm.deleteComponent()},"cancel":function($event){_vm.isEditing = false},"update":function($event){_vm.updateComponent()}}})],1)],1)]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/26.89848d8d9b178bfc409f.js